import React, {useRef, useState} from "react";
import PropTypes from "prop-types";
import { FormSectionWrapper } from "../";
import { injectIntl } from "react-intl";
import { change } from "redux-form";
import {
  Address,
  Agreements,
  Credentials,
  Personal,
  RequiredFieldFooterNote,
  PhoneNumberField
} from "../../fieldGroups";
import IsEbikeOnly from "../../fieldGroups/isEbikeOnly";
import * as selectors from "../../../../selectors";
import { connect } from "react-redux";
import { Txt } from "../../../../elements";
import { messages, constants } from "../../../../constants";

import ReCAPTCHA from 'react-google-recaptcha';

const PersonalInfo = (props) => {
  const { intl, dispatch, isEvoOnlyMode, isFromEvolvePrivateReg } = props;

  const showEvoAndEvolveChoice = 
    !isEvoOnlyMode // Feature to only show Evo options is off OR
    || isFromEvolvePrivateReg; // User came from Evolve private registration (B2B new customer)
  const reactAppEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true';

  const recaptchaRef = useRef(null);
  const [verified, setVerified] = useState(false || !reactAppEnabled);

  const handleCaptchaChange = (token) => {
    setVerified(!!token);
    dispatch(change(constants.FORM.registrationForm, "personalInfo.recaptchaToken", token));
  };

  return (
    <div>
      <FormSectionWrapper {...props}>
        <Personal {...props} />
        <Credentials {...props} />
        <PhoneNumberField {...props} />
        <br />
        <Address {...props} prefix={"address"} />
        <Agreements {...props} />
        <RequiredFieldFooterNote {...props} />
        <br />
        {(reactAppEnabled) && (
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={handleCaptchaChange}
            ref={recaptchaRef}
          />
        )}
        <br />
        {showEvoAndEvolveChoice && (
          <FormSectionWrapper {...props} title={intl.formatMessage(messages.title.EvoEvolveIcon)}>
            <Txt theme={["note"]}>{intl.formatMessage(messages.text.evolveOrBoth)}</Txt>
            <IsEbikeOnly {...props} recaptchaVerified={verified} />
          </FormSectionWrapper>
        )}
      </FormSectionWrapper>
    </div>
  );
};

PersonalInfo.propTypes = {
  intl: PropTypes.object.isRequired,
  isEbikeOnly: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isEbikeOnly: selectors.getIsEbikeOnly(state),
  isEvoOnlyMode: selectors.getIsEvoOnlyMode(state),
  isFromEvolvePrivateReg: selectors.getIsFromEvolvePrivateReg(state)
});

export default injectIntl(connect(mapStateToProps)(PersonalInfo));
